module.exports = __webpack_public_path__ + "static/media/5.1a7e5c72.jpg";